import * as React from "react"
import { getActionables } from "../ActionableSet/utils"

type Props = {
  children: React.ReactNode
}

const FocusInside = ({ children }: Props) => {
  const localRef = React.createRef<HTMLDivElement>()

  React.useEffect(() => {
    if (!localRef.current) return

    const actionables = getActionables(localRef.current)
    actionables?.[0]?.focus({ preventScroll: true })
  }, [localRef])

  return <div ref={localRef}>{children}</div>
}

export default FocusInside
